import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';

import { Container, Row, Button, Alert } from 'reactstrap';

//_Partials
import Header from "../../_partials/Header/Header";
import Sidebar from "../../_partials/Sidebar/Sidebar";

// Styles
import "./Events.css";

class Events extends Component {

    constructor(props){
        super(props);
        this.state = {
            deleteMsg: false,
            events: ""
        }

        this.compare = (a, b) => {
          if (moment(a.date).isSame(b.date, 'day')) {
            return moment(a.start_time).isBefore(b.start_time, 'minute') ? -1 : 1
          }
          return moment(a.date).isBefore(b.date, 'day') ? -1 : 1
        }

        this.deleteEvent = this.deleteEvent.bind(this);
    }

    deleteEvent = (eventID) => {
        var record = JSON.parse(localStorage.getItem("key"));
        var token = record.token;
        axios({
            method: 'delete',
            url: '/event/' + eventID,
            headers : {
                "x-access-token" : token
            }
        })
        .then(res => {
          if (res.status === 200) {

            this.setState({deleteMsg: res.data});

            axios.get(`/events`)
            .then(res => {
                this.setState({ events: res.data });
            })

          }
        })
    }

    tableEvents = (data) => {
        let table = []
        if (data) {
          data = data.sort((a, b) => this.compare(a, b));
        }
        for (let i = 0; i < data.length; i++) {

            let children = [];

            children.push(<td key="title">{data[i].title}</td>)
            children.push(<td key="venue">{data[i].venue}</td>)
            children.push(<td key="desc">{data[i].description.substring(0, 50)}</td>)
            children.push(<td key="price">{data[i].price}</td>)
            children.push(<td key="date">{moment(data[i].date).format('DD MMM YYYY')}</td>)
            children.push(<td key="time">{`${moment(data[i].start_time).format('HH:mm')} - ${moment(data[i].end_time).format('HH:mm')}`}</td>)
            children.push(<td key="at">{moment(data[i].updated_at).format('YYYY-MM-DD HH:mm')}</td>)
            children.push(<td key="action"><a href={"/admin/event/edit/" + data[i].id} className="btn btn-primary btn-sm">Edit</a> <Button color="danger" size="sm" onClick={ () => { if (window.confirm('Are you sure you wish to delete this event?')) this.deleteEvent(data[i].id) } }>Delete</Button></td>)

            table.push(<tr key={"row"+i}>{children}</tr>)

        }
        return table;
    }
    

    componentDidMount() {
        axios.get(`/events`)
          .then(res => {
            this.setState({ events: res.data });
        })
    }
    
    render() {
        return (
        <div className="AdminEvents">
            <Header />
            <Container fluid>
                <Row>
                    <Sidebar />
                    <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
                        <h2>Calendar Events <a className="float-right" href="/admin/event/add">Add New Event</a></h2>
                        { this.state.deleteMsg 
                            && <Alert color="success">{(this.state.deleteMsg)}</Alert>
                        }
                        <div className="table-responsive">
                            <table className="table table-striped table-sm" style={{ color: 'white' }}>
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Venue</th>
                                    <th>Description</th>
                                    <th>Price</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Updated At</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.tableEvents(this.state.events)}
                            </tbody>
                            </table>
                        </div>
                    </main>
                </Row>
            </Container>
        </div>
        );
    }
}
export default Events;
